import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './styles.css'

const client = new QueryClient({
  defaultOptions: {
    queries: {
      // Un dossier médical se relit volontiers : on ne garde pas longtemps une
      // version périmée à l'écran.
      staleTime: 10_000,
      refetchOnWindowFocus: true,
      retry: (nb, erreur) => {
        const statut = (erreur as { statut?: number }).statut
        if (statut === 401 || statut === 404) return false
        return nb < 1
      },
    },
  },
})

createRoot(document.getElementById('racine')!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
